var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguageButtonEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;fill:none;stroke:#FFFFFF;stroke-width:0.1;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#BABABA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 50,
    height: 50
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 25,
    cy: 25,
    r: 21.5
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25,6C14.5,6,6,14.5,6,25s8.5,19,19,19s19-8.5,19-19S35.5,6,25,6z M25,40.4c-8.5,0-15.4-6.9-15.4-15.4 S16.5,9.6,25,9.6S40.4,16.5,40.4,25S33.5,40.4,25,40.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageButtonEmpty);
export default __webpack_public_path__ + "static/media/language_button_empty.18cf956e59bf08b51577e4f4ae0a5120.svg";
export { ForwardRef as ReactComponent };